import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadSZLTByIdFailed, loadSZLTByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadSZLTById(action) {
  try {
    const url = `${BACKEND_URL}/v1/registries/order-services/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadSZLTByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadSZLTByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadSZLTByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
